import initMainMenu from '../../modules/menu';
import initLanguageSwitcher from '../../modules/lang';
import initGTM from '../../modules/gtm';
import initBar from '../../modules/bar';
import {bannerDaring} from '../../modules/banners';
import CookieBanner from '../../modules/cookie-banner';
import ClickTracker from '../../../shared/click-tracker/click-tracker';

import 'normalize.css';
import './main.scss';

document.addEventListener('DOMContentLoaded', () => {
  initLanguageSwitcher();
  initMainMenu();
  initBar();
  initGTM();
  bannerDaring();

  new ClickTracker().init();

  new CookieBanner('.cookie-banner');
});
